import { __decorate } from "tslib";
import { customElement } from '@microsoft/fast-element';
import { Checkbox, CheckboxTemplate as template } from '@microsoft/fast-foundation';
import { CheckboxStyles as styles } from './checkbox.styles';
/**
 * The Fluent Checkbox Element. Implements {@link @microsoft/fast-foundation#Checkbox},
 * {@link @microsoft/fast-foundation#CheckboxTemplate}
 *
 *
 * @public
 * @remarks
 * HTML Element: \<fluent-checkbox\>
 */
let FluentCheckbox = class FluentCheckbox extends Checkbox {
};
FluentCheckbox = __decorate([
    customElement({
        name: 'fluent-checkbox',
        template,
        styles,
        shadowOptions: {
            mode: 'closed',
        },
    })
], FluentCheckbox);
export { FluentCheckbox };
/**
 * Styles for Checkbox
 * @public
 */
export const CheckboxStyles = styles;
